module.exports = __webpack_public_path__ + "img/location-tip.7feea5cf.jpg";